/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeHeroType } from './ChallengeHeroType';
import {
    ChallengeHeroTypeFromJSON,
    ChallengeHeroTypeFromJSONTyped,
    ChallengeHeroTypeToJSON,
    ChallengeHeroTypeToJSONTyped,
} from './ChallengeHeroType';
import type { ChallengeResponsiveTypography } from './ChallengeResponsiveTypography';
import {
    ChallengeResponsiveTypographyFromJSON,
    ChallengeResponsiveTypographyFromJSONTyped,
    ChallengeResponsiveTypographyToJSON,
    ChallengeResponsiveTypographyToJSONTyped,
} from './ChallengeResponsiveTypography';

/**
 * Hero section configuration for challenge pages. Supports either image or video background with text overlay, CTA, and gradient.
 * @export
 * @interface PageHeroSection
 */
export interface PageHeroSection {
    /**
     * 
     * @type {ChallengeHeroType}
     * @memberof PageHeroSection
     */
    heroType?: ChallengeHeroType;
    /**
     * Asset ID for hero background image (when heroType is IMAGE)
     * @type {string}
     * @memberof PageHeroSection
     */
    heroImageId?: string;
    /**
     * CDN URL for hero image (in response)
     * @type {string}
     * @memberof PageHeroSection
     */
    heroImageUrl?: string;
    /**
     * Additional hero asset ids. The surface picks one per page load so a long-running campaign is not the same picture every visit. Additive — heroImageId remains the primary and joins the rotation.
     * @type {Array<string>}
     * @memberof PageHeroSection
     */
    heroImageRotationIds?: Array<string>;
    /**
     * Resolved CDN urls for the rotation, authored order (response only).
     * @type {Array<string>}
     * @memberof PageHeroSection
     */
    heroImageRotationUrls?: Array<string>;
    /**
     * External URL for hero image — used as fallback when no heroImageId is set (e.g. direct display of external image without uploading to CDN)
     * @type {string}
     * @memberof PageHeroSection
     */
    heroImageExternalUrl?: string;
    /**
     * URL to hero video file (when heroType is VIDEO, MP4 recommended)
     * @type {string}
     * @memberof PageHeroSection
     */
    videoUrl?: string;
    /**
     * Asset ID for video poster/thumbnail (when heroType is VIDEO)
     * @type {string}
     * @memberof PageHeroSection
     */
    videoPosterImageId?: string;
    /**
     * CDN URL for video poster (in response)
     * @type {string}
     * @memberof PageHeroSection
     */
    videoPosterImageUrl?: string;
    /**
     * Optional eyebrow label rendered above the hero title (e.g. "Season 4.5 · Live Now"). When set, the consumer (custom hub) renders it as a small uppercase pill above the title. Empty/unset hides the eyebrow.
     * @type {string}
     * @memberof PageHeroSection
     */
    eyebrowText?: string;
    /**
     * Hero title text (can include line breaks)
     * @type {string}
     * @memberof PageHeroSection
     */
    title?: string;
    /**
     * Hero description/subtitle text
     * @type {string}
     * @memberof PageHeroSection
     */
    description?: string;
    /**
     * Call-to-action button text (e.g., "Enter Now", "Get Started")
     * @type {string}
     * @memberof PageHeroSection
     */
    ctaText?: string;
    /**
     * CTA button background color. Any colour the API accepts —
     * @type {string}
     * @memberof PageHeroSection
     */
    ctaBackgroundColor?: string;
    /**
     * CTA button text color. Any colour the API accepts —
     * @type {string}
     * @memberof PageHeroSection
     */
    ctaTextColor?: string;
    /**
     * Whether to show gradient overlay on hero (for text readability)
     * @type {boolean}
     * @memberof PageHeroSection
     */
    showGradientOverlay?: boolean;
    /**
     * Gradient start color (top). Any colour the API accepts —
     * @type {string}
     * @memberof PageHeroSection
     */
    gradientStartColor?: string;
    /**
     * Gradient end color (bottom). Any colour the API accepts —
     * @type {string}
     * @memberof PageHeroSection
     */
    gradientEndColor?: string;
    /**
     * Percentage of hero height that gradient covers (0-100, from bottom up)
     * @type {number}
     * @memberof PageHeroSection
     */
    gradientCoverage?: number;
    /**
     * Opacity of the gradient overlay (0-100, where 100 is fully opaque)
     * @type {number}
     * @memberof PageHeroSection
     */
    gradientOpacity?: number;
    /**
     * CSS gradient direction (e.g. "to top", "270deg", "to right"). Default is "to top" (bottom-up).
     * @type {string}
     * @memberof PageHeroSection
     */
    gradientDirection?: string;
    /**
     * default is full-width with game sidebar, split is two-column with widget zone
     * @type {string}
     * @memberof PageHeroSection
     */
    heroLayout?: PageHeroSectionHeroLayoutEnum;
    /**
     * Content block ID to render in split layout widget zone (e.g. MY_POSITION or COUNTDOWN block)
     * @type {string}
     * @memberof PageHeroSection
     */
    splitWidgetBlockId?: string;
    /**
     * 
     * @type {ChallengeResponsiveTypography}
     * @memberof PageHeroSection
     */
    titleTypography?: ChallengeResponsiveTypography;
    /**
     * 
     * @type {ChallengeResponsiveTypography}
     * @memberof PageHeroSection
     */
    subtitleTypography?: ChallengeResponsiveTypography;
    /**
     * 
     * @type {ChallengeResponsiveTypography}
     * @memberof PageHeroSection
     */
    descriptionTypography?: ChallengeResponsiveTypography;
}


/**
 * @export
 */
export const PageHeroSectionHeroLayoutEnum = {
    default: 'default',
    split: 'split'
} as const;
export type PageHeroSectionHeroLayoutEnum = typeof PageHeroSectionHeroLayoutEnum[keyof typeof PageHeroSectionHeroLayoutEnum];


/**
 * Check if a given object implements the PageHeroSection interface.
 */
export function instanceOfPageHeroSection(value: object): value is PageHeroSection {
    return true;
}

export function PageHeroSectionFromJSON(json: any): PageHeroSection {
    return PageHeroSectionFromJSONTyped(json, false);
}

export function PageHeroSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageHeroSection {
    if (json == null) {
        return json;
    }
    return {
        
        'heroType': json['heroType'] == null ? undefined : ChallengeHeroTypeFromJSON(json['heroType']),
        'heroImageId': json['heroImageId'] == null ? undefined : json['heroImageId'],
        'heroImageUrl': json['heroImageUrl'] == null ? undefined : json['heroImageUrl'],
        'heroImageRotationIds': json['heroImageRotationIds'] == null ? undefined : json['heroImageRotationIds'],
        'heroImageRotationUrls': json['heroImageRotationUrls'] == null ? undefined : json['heroImageRotationUrls'],
        'heroImageExternalUrl': json['heroImageExternalUrl'] == null ? undefined : json['heroImageExternalUrl'],
        'videoUrl': json['videoUrl'] == null ? undefined : json['videoUrl'],
        'videoPosterImageId': json['videoPosterImageId'] == null ? undefined : json['videoPosterImageId'],
        'videoPosterImageUrl': json['videoPosterImageUrl'] == null ? undefined : json['videoPosterImageUrl'],
        'eyebrowText': json['eyebrowText'] == null ? undefined : json['eyebrowText'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'ctaText': json['ctaText'] == null ? undefined : json['ctaText'],
        'ctaBackgroundColor': json['ctaBackgroundColor'] == null ? undefined : json['ctaBackgroundColor'],
        'ctaTextColor': json['ctaTextColor'] == null ? undefined : json['ctaTextColor'],
        'showGradientOverlay': json['showGradientOverlay'] == null ? undefined : json['showGradientOverlay'],
        'gradientStartColor': json['gradientStartColor'] == null ? undefined : json['gradientStartColor'],
        'gradientEndColor': json['gradientEndColor'] == null ? undefined : json['gradientEndColor'],
        'gradientCoverage': json['gradientCoverage'] == null ? undefined : json['gradientCoverage'],
        'gradientOpacity': json['gradientOpacity'] == null ? undefined : json['gradientOpacity'],
        'gradientDirection': json['gradientDirection'] == null ? undefined : json['gradientDirection'],
        'heroLayout': json['heroLayout'] == null ? undefined : json['heroLayout'],
        'splitWidgetBlockId': json['splitWidgetBlockId'] == null ? undefined : json['splitWidgetBlockId'],
        'titleTypography': json['titleTypography'] == null ? undefined : ChallengeResponsiveTypographyFromJSON(json['titleTypography']),
        'subtitleTypography': json['subtitleTypography'] == null ? undefined : ChallengeResponsiveTypographyFromJSON(json['subtitleTypography']),
        'descriptionTypography': json['descriptionTypography'] == null ? undefined : ChallengeResponsiveTypographyFromJSON(json['descriptionTypography']),
    };
}

export function PageHeroSectionToJSON(json: any): PageHeroSection {
    return PageHeroSectionToJSONTyped(json, false);
}

export function PageHeroSectionToJSONTyped(value?: PageHeroSection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'heroType': ChallengeHeroTypeToJSON(value['heroType']),
        'heroImageId': value['heroImageId'],
        'heroImageUrl': value['heroImageUrl'],
        'heroImageRotationIds': value['heroImageRotationIds'],
        'heroImageRotationUrls': value['heroImageRotationUrls'],
        'heroImageExternalUrl': value['heroImageExternalUrl'],
        'videoUrl': value['videoUrl'],
        'videoPosterImageId': value['videoPosterImageId'],
        'videoPosterImageUrl': value['videoPosterImageUrl'],
        'eyebrowText': value['eyebrowText'],
        'title': value['title'],
        'description': value['description'],
        'ctaText': value['ctaText'],
        'ctaBackgroundColor': value['ctaBackgroundColor'],
        'ctaTextColor': value['ctaTextColor'],
        'showGradientOverlay': value['showGradientOverlay'],
        'gradientStartColor': value['gradientStartColor'],
        'gradientEndColor': value['gradientEndColor'],
        'gradientCoverage': value['gradientCoverage'],
        'gradientOpacity': value['gradientOpacity'],
        'gradientDirection': value['gradientDirection'],
        'heroLayout': value['heroLayout'],
        'splitWidgetBlockId': value['splitWidgetBlockId'],
        'titleTypography': ChallengeResponsiveTypographyToJSON(value['titleTypography']),
        'subtitleTypography': ChallengeResponsiveTypographyToJSON(value['subtitleTypography']),
        'descriptionTypography': ChallengeResponsiveTypographyToJSON(value['descriptionTypography']),
    };
}

